"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'onboarding.wizard.title': 'Onboarding Wizard',
    'onboarding.wizard.reset': 'Reset',
    'onboarding.wizard.loading': 'Loading...',
    'onboarding.wizard.step.progress': 'Step {current} of {total}',
    'onboarding.wizard.tab.profession': 'Choose Profession',
    'onboarding.wizard.tab.steps': 'Complete Steps',
    'onboarding.wizard.tab.review': 'Review',
    'onboarding.wizard.tab.completed': 'Completed',
    'onboarding.wizard.profession.title': 'Choose Your Profession',
    'onboarding.wizard.profession.subtitle': 'Select the profession that best matches your role to get customized onboarding steps.',
    'onboarding.wizard.profession.select': 'Select',
    'onboarding.wizard.profession.selected': 'Selected',
    'onboarding.wizard.profession.continue': 'Continue with {profession}',
    'onboarding.wizard.profession.loading': 'Loading professions...',
    'onboarding.wizard.profession.empty': 'No professions available. Please contact your administrator.',
    'onboarding.wizard.navigation.previous': 'Previous',
    'onboarding.wizard.navigation.next': 'Next Step',
    'onboarding.wizard.navigation.complete': 'Complete Onboarding',
    'onboarding.wizard.navigation.backToSteps': 'Back to Steps',
    'onboarding.wizard.navigation.confirmComplete': 'Confirm & Complete',
    'onboarding.wizard.questions.placeholder': 'Enter your answer...',
    'onboarding.wizard.questions.required': '*',
    'onboarding.wizard.questions.selectOption': 'Please select an option...',
    'onboarding.wizard.questions.empty': 'No questions available for this step.',
    'onboarding.wizard.review.title': 'Review Your Onboarding',
    'onboarding.wizard.review.subtitle': 'Please review your answers before completing the onboarding process.',
    'onboarding.wizard.review.profession': 'Selected Profession',
    'onboarding.wizard.review.steps': 'Completed Steps',
    'onboarding.wizard.review.notSelected': 'Not selected',
    'onboarding.wizard.completed.title': 'Onboarding Completed!',
    'onboarding.wizard.completed.message': 'Congratulations! You have successfully completed the onboarding process for {profession}.',
    'onboarding.wizard.completed.fallback': 'your profession',
    'onboarding.wizard.completed.startNew': 'Start New Onboarding',
};
